const imsrconfig = {
  stage: "hotfix821",
  endpoint: "https://api.hotfix821.dev.pescle.com/",
  movie: "https://d3qn0e6p89or06.cloudfront.net/",
  imageUpload: "https://fileapi-dev.pescle.com/image_upload", // TODO: *.dev.pescle.com にリプレース
  apikey: "nr73MrAiXBw7xM5LMJYNW4UTtkWEy5e89hnYMiw2",
  ga4Id: "G-3781V7QS89",
};

export default imsrconfig;
